// removed by extract-text-webpack-plugin
module.exports = {"SideDrawer":"SideDrawer__SideDrawer__3hWqq","LogoContainer":"SideDrawer__LogoContainer__3Z6p3","Open":"SideDrawer__Open__28kUY","Closed":"SideDrawer__Closed__U86AE","MobileMenuTitle":"SideDrawer__MobileMenuTitle__1GOhW","MenuList":"SideDrawer__MenuList__2ZUNh","Alt":"SideDrawer__Alt__3vsc3","ActiveMenu":"SideDrawer__ActiveMenu__2qzy8","CloseButton":"SideDrawer__CloseButton__1Ehyu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SideDrawer/SideDrawer.css
// module id = 177
// module chunks = 0